<div class="wrapper margin-bottom">
  @if (currentMode === modes.Create) {
    <div class="grid-container request">
      <eDiscovery-new-request  [organization]="organization" [newRequest]="newRequest" (errorOccurred)="showError($event)" (organizationChanged)="organizationChanged($event)" (requestCancelled)="onRequestCancelled($event)"></eDiscovery-new-request>
    </div>
  }
  @if (currentMode === modes.Search) {
    <div class="grid-container search">
      <eDiscovery-request-search [organization]="organization" (organizationChanged)="organizationChanged($event)" [searchRequest]="searchRequest" (searchParamsChanged)="paramsChanged($event)" (runSearch)="runSearch($event)" (startNewRequest)="startNew($event)" (errorOccurred)="showError($event)"></eDiscovery-request-search>
    </div>
  }
  @if (currentMode === modes.Search) {
    <div class="margin-top search">
      <div  class="grid-x">
        @if (showSearchResults) {
          <div class="cell large-12">
            <eDiscovery-search-results [availableOrganizations]="allOrganizations" [organization]="organization" [searchRequest]="searchRequest"></eDiscovery-search-results>
          </div>
        }
      </div>
    </div>
  }
</div>
